import {scrollSlidesA11y} from "../utils/swiperA11y";

export default class BlockSliderMultiple {
	constructor() {
		let blocks = document.querySelectorAll('.block-slider-multiple');

		blocks.forEach(block => {
			let swiper = block.querySelector(".swiper");
            const prev = swiper.querySelector(".navigation-button-prev");
            const next = swiper.querySelector(".navigation-button-next");
			new Swiper(swiper, {
				slidesPerView: "auto",
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				...scrollSlidesA11y,
			});
		});
	}
}
